module.exports = function (context, options) {
  if (context.length > 0 && context[0] === 'Aqua') {
    // placement colors (multiples of 10 to support more than 10)
    return context[options % 10];
  }
  return context[options];
};
